import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import ChipButtons from '@/ui-components/ChipButtons.vue';
import ChipButton from '@/ui-components/ChipButton.vue';

import { ObjectType } from '@/@types/graphql-types';
import { usePlotRecommenderStore } from './usePlotRecommenderStore';

import { useI18n } from '@/helpers/composables/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlotRecommenderContentTypeFilter',
  setup(__props) {

const prStore = usePlotRecommenderStore();

const { tc } = useI18n();

const contentTypes = computed(() => {
	const contentTypes = prStore.filters.objectTypes;

	return [
		{
			key: 'WEBAPP_ALL_TITLES',
			translation: tc('WEBAPP_ALL_TITLES'),
			isActive: contentTypes.length === 0,
			value: null,
		},
		{
			key: 'WEBAPP_MOVIES',
			translation: tc('WEBAPP_MOVIES'),
			isActive: contentTypes[0] === ObjectType.Movie,
			value: ObjectType.Movie,
		},
		{
			key: 'WEBAPP_TVSHOWS',
			translation: tc('WEBAPP_TVSHOWS'),
			isActive: contentTypes[0] === ObjectType.Show,
			value: ObjectType.Show,
		},
	];
});

function toggle(contentType: ObjectType | null) {
	prStore.filters.objectTypes = contentType ? [contentType] : [];
}

return { __sfc: true,prStore, tc, contentTypes, toggle, ChipButtons, ChipButton }
}

})